import { Button, Modal } from '@fasstech/middle-design-system';
import {
  ControlledDatePicker,
  ControlledInput,
  ControlledSelect,
  ControlledSSInput
} from '@@viewCommonComponents/controlled';
import { isRequired } from '@@viewValidations';
import { civilityOptions } from '@@viewCommonComponents/forms/options';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';
import { isRequiredSelect } from '@@viewHelpers/validations/index.js';
import { FormLayout } from '@@viewCommonComponents/forms/Layouts.jsx';

const ReferentModal = ({
  setDisplayReferentModal,
  form,
  getFieldsName,
  getMiddleText,
  onSubmitReferentForm,
  displayReferentModal
}) => {
  return (
    <Modal
      isDisplayed={displayReferentModal}
      onClose={() => setDisplayReferentModal(false)}
      icon="informations_beneficiaire"
      iconSize={60}
      containerClassName="px-3"
      className="p-6 w-[800px]">
      <FormLayout>
        <ControlledSelect
          name={getFieldsName('attachedSocialSecurities.0.civility')}
          label={getMiddleText('BENEFICIAIRE_CIVILITE_LABEL')}
          form={form}
          options={civilityOptions}
          rules={isRequiredSelect(civilityOptions)}
          data-testid="REFERENT_CIVILITE"
        />

        <ControlledDatePicker
          name={getFieldsName('attachedSocialSecurities.0.birthDate')}
          label={getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_LABEL')}
          form={form}
          rules={isRequired}
          triggerOnChange
          data-testid="REFERENT_DATE_NAISSANCE"
        />

        <ControlledInput
          name={getFieldsName('attachedSocialSecurities.0.lastName')}
          label={getMiddleText('BENEFICIAIRE_NOM_LABEL')}
          form={form}
          rules={isRequired}
          data-testid="REFERENT_NOM"
        />

        <ControlledInput
          name={getFieldsName('attachedSocialSecurities.0.firstName')}
          label={getMiddleText('BENEFICIAIRE_PRENOM_LABEL')}
          form={form}
          rules={isRequired}
          data-testid="REFERENT_PRENOM"
        />

        <ControlledSSInput
          label={getMiddleText('BENEFICIAIRE_NSS_LABEL')}
          SSInputName={getFieldsName('attachedSocialSecurities.0.number')}
          birthDateInputName={getFieldsName('attachedSocialSecurities.0.birthDate')}
          form={form}
          mandatory
          data-testid="REFERENT_NSS"
        />
        <div className={'flex justify-between w-full'}>
          <Button onClick={() => setDisplayReferentModal(false)} variant="secondary">
            {'Annuler'}
          </Button>

          <Button
            onClick={async () => ((await form.trigger()) ? onSubmitReferentForm() : null)}
            variant="primary"
            disabled={isNotNilOrEmpty(form.formState.errors) || !form.formState.isValid}
            data-testid="ADD_REFERENT_BUTTON">
            {getMiddleText('ADD_REFERENT_BUTTON')}
          </Button>
        </div>
      </FormLayout>
    </Modal>
  );
};

export default ReferentModal;
